const menu = {
  key: "customers",
  route: "/legacy/customers",
  label: "sidebar.customers",
  icon: "faUsers",
  group: "sales",
  order: 10,
  permission: "legacy.customers.read"
};

export default menu;